/** Product-handle list fields (`type: "product_list"`).
 *
 *  The stored value is a NEWLINE-JOINED STRING, not an array — deliberately, and
 *  that is the whole reason this file exists. These fields shipped as plain
 *  textareas ("one product handle per line") long before the picker did, so a
 *  theme in a live store already holds that shape and the storefront reads it
 *  straight out of the saved document. Keeping the shape means the picker is a
 *  pure editor change: no theme migration, nothing to re-save, and a seller who
 *  typed handles by hand sees them come back as chips.
 *
 *  Parsing is permissive for the same reason. Anything a seller could reasonably
 *  have typed into the old textarea has to keep resolving: commas as well as
 *  newlines (a comma-separated line used to be read as ONE nonexistent handle and
 *  silently rendered nothing), stray whitespace, and duplicates. An array is
 *  accepted too so a future writer that stores one cannot break the readers.
 */
/** Split a stored handle-list value into clean handles, in the stored order. */
export function parseHandleList(value) {
    const raw = Array.isArray(value) ? value.map(v => String(v ?? "")) : String(value ?? "").split(/[\n,]/);
    const out = [];
    const seen = new Set();
    for (const item of raw) {
        const h = item.trim();
        // A duplicate is never what the seller means: the same product would be
        // fetched twice and offered twice in one strip.
        if (!h || seen.has(h))
            continue;
        seen.add(h);
        out.push(h);
    }
    return out;
}
/** Serialize picked handles back into the stored shape. */
export function serializeHandleList(handles) {
    return parseHandleList(handles).join("\n");
}
//# sourceMappingURL=handle-list.js.map